<script>
import { mapGetters } from 'vuex';

export default {
  // model: {
  //   prop: 'sorting',
  //   event: 'sorting-change'
  // },

  data: () => ({
    onClickTimer: null,
    onClickDelay: 300,
    internalSorting: [] 
  }),

  computed: {
    ...mapGetters({
      sorting: 'searchSort'
    })
  },

  watch: {
    sorting: {
      handler: function(newArr) {
        this.internalSorting = newArr.map(item => Object.assign({}, item))
      },
      deep: true
    }
  },

  created() {
    this.internalSorting = this.sorting.map(item => Object.assign({}, item));
  },

  methods: {
    getSortIcon(item) {
      return item.asc ? '#sort-asc' : '#sort-desc';
    },
    onSortItemClick(item) {
      // Устанавливаем таймер, чтобы предотвратить обработку клика по элементу
      // в случае, если пользователь выполнил двойной клик.
      this.onClickTimer = setTimeout(() => {
        this.onClickTimer = null;
        if (item.active) {
          item.asc = !item.asc;
        } else {
          item.active = true;
        }
        this.$store.dispatch('setNewSortOrder', this.internalSorting);
      }, this.onClickDelay);
    },
    onSortItemDoubleClick(item) {
      // Если установлен таймер обработчика одинарного клика, то отменяем
      // его, чтобы предотвратить ложное срабатывание.
      if (this.onClickTimer) {
        clearTimeout(this.onClickTimer);
        this.onClickTimer = null;
      }
      item.active = !item.active;
      this.$store.dispatch('setNewSortOrder', this.internalSorting);
    }
  }
};
</script>
